export const BULK_CHANGES_REQUEST = 'BULK_CHANGES_REQUEST';
export const BULK_CHANGES_ERROR = 'BULK_CHANGES_ERROR';
export const BULK_CHANGES_SUCCESS = 'BULK_CHANGES_SUCCESS';
